import React, { useEffect } from "react";
import Wrapper from "./shared/Wrapper";
import Footer from "./shared/Footer";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

// Import des composants de projets
import AnimatedBackground from "../components/accueil/AnimatedBackground";
import ChallengerProject from "../components/projets/challenger/ChallengerProject";
import MobseProject from "../components/projets/mobse/MobseProject";
import GreenChallengerProject from "../components/projets/green_challenger/GreenChallengerProject";
import ReassproProject from "../components/projets/reasspro/reasspro_web";
import FloatingElement from "../components/AnimatedSection";

gsap.registerPlugin(ScrollTrigger);

export default function Projets() {
    const navigate = useNavigate();

    useEffect(() => {
        // Animation GSAP pour les titres
        gsap.fromTo(
            ".project-hero-title",
            { y: 80, opacity: 0 },
            {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: "power3.out",
                stagger: 0.15,
            }
        );

        // Animation scroll-triggered pour les sections de projets
        gsap.fromTo(
            ".project-section",
            { opacity: 0, y: 100 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: ".project-section",
                    start: "top 80%",
                    end: "bottom 20%",
                    toggleActions: "play none none none",
                },
            }
        );
    }, []);

    return (
        <div className="bg-black text-white overflow-hidden">
            {/* ================================================ */}
            {/* BACKGROUND IDENTIQUE AUX AUTRES PAGES */}
            {/* ================================================ */}




            {/* ================================================ */}
            {/* BACKGROUND GLOBAL AVEC LES ÉLÉMENTS TECH */}
            {/* ================================================ */}
            <AnimatedBackground variant="global" showNeuralNodes={true} showParticles={true} />

            {/* Fond de dégradé principal */}
            <div className="fixed inset-0 bg-linear-to-br from-gray-900 via-black to-blue-900 z-0" />

            {/* Radial gradient pour effet de profondeur */}
            <div className="fixed inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(6,182,212,0.1),transparent_50%)] z-0" />

            {/* Étoiles animées (20 étoiles) */}
            <div className="fixed inset-0 overflow-hidden z-0">
                {[...Array(20)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute w-1 h-1 bg-cyan-400/30 rounded-full"
                        initial={{
                            x: Math.random() * 100 + "vw",
                            y: Math.random() * 100 + "vh",
                        }}
                        animate={{
                            x: [null, Math.random() * 100 + "vw"],
                            y: [null, Math.random() * 100 + "vh"],
                        }}
                        transition={{
                            duration: 20 + Math.random() * 10,
                            repeat: Infinity,
                            ease: "linear",
                        }}
                    />
                ))}
            </div>

            {/* Éléments flottants de fond */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none">
                <FloatingElement x={10} y={20} color="bg-blue-500/10" size={300} delay={0} />
                <FloatingElement x={80} y={40} color="bg-purple-500/10" size={200} delay={0.5} />
                <FloatingElement x={30} y={70} color="bg-cyan-500/10" size={250} delay={1} />
                <FloatingElement x={70} y={10} color="bg-emerald-500/10" size={180} delay={1.5} />
            </div>

            <Wrapper>
                {/* ================================================ */}
                {/* SECTION HERO */}
                {/* ================================================ */}
                <section className="relative py-14 md:py-20 lg:py-20 overflow-hidden">
                    <div className="container mx-auto px-4 text-center relative z-10">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            className="max-w-5xl mx-auto"
                        >
                            {/* Badge Premium */}
                            {/* <div className="mb-6 md:mb-8">
                                <div className="inline-flex items-center gap-2 px-4 py-2 md:px-5 md:py-2.5 rounded-full bg-white/[0.03] border border-white/[0.08] backdrop-blur-md shadow-[0_0_20px_rgba(59,130,246,0.1)]">
                                    <Sparkles className="w-4 h-4 text-blue-400" />
                                    <span className="text-blue-300 text-xs md:text-sm font-medium tracking-wider uppercase">
                                        Portfolio Premium
                                    </span>
                                </div>
                            </div> */}

                            {/* Titre principal */}
                            <h1 className="project-hero-title text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6 md:mb-8 leading-tight tracking-tight">
                                Nos{" "}
                                <span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-600 bg-clip-text text-transparent">
                                    Projets
                                </span>
                                {/* Premium */}
                            </h1>

                            {/* Description */}
                            <p className="project-hero-title text-gray-300 text-base sm:text-xl mb-10 md:mb-12 max-w-3xl mx-auto leading-relaxed px-4">
                                Découvrez notre expertise à travers des projets concrets qui transforment
                                les défis en solutions innovantes et performantes.
                            </p>
                        </motion.div>
                    </div>
                </section>

                {/* ================================================ */}
                {/* SECTION INTRODUCTION STRATÉGIQUE */}
                {/* ================================================ */}
                {/* <section className="relative py-12 md:py-16">
                    <div className="container mx-auto px-4">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                            className="max-w-4xl mx-auto text-center"
                        >
                            <p className="text-gray-300 text-base sm:text-lg leading-relaxed mb-8">
                                Chez{" "}
                                <span className="text-blue-400 font-semibold">Myriade</span>,
                                nous croyons que chaque projet est une opportunité de démontrer notre
                                expertise technique et notre capacité à livrer des solutions qui
                                dépassent les attentes.
                            </p>

                          
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
                                {[
                                    { icon: "🚀", title: "Innovation", desc: "Technologies de pointe" },
                                    { icon: "💎", title: "Qualité", desc: "Excellence à chaque étape" },
                                    { icon: "📈", title: "Impact", desc: "Résultats mesurables" },
                                ].map((value, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: index * 0.1, duration: 0.6 }}
                                        className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 hover:bg-white/10 hover:border-white/20 transition-all duration-300"
                                    >
                                        <div className="text-4xl mb-3">{value.icon}</div>
                                        <h3 className="text-lg sm:text-xl font-bold text-white mb-2">
                                            {value.title}
                                        </h3>
                                        <p className="text-gray-400 text-sm md:text-base">{value.desc}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>
                    </div>
                </section> */}

                {/* ================================================ */}
                {/* SECTION PROJETS */}
                {/* ================================================ */}
                <section className="project-section relative py-16 md:py-0">
                    <div className="container mx-auto px-4">
                        {/* Titre de section */}
                        {/* <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className="text-4xl sm:text-5xl md:text-7xl font-bold text-white text-center mb-16 md:mb-24"
                        >
                            Découvrez nos{" "}
                            <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
                                réalisations
                            </span>
                        </motion.h2> */}


                        {/* Projet 4: Reasspro */}
                        <ReassproProject />

                        {/* Projet 1: Challenger */}
                        <ChallengerProject />

                        {/* Projet 2: Mobse */}
                        <MobseProject />

                        {/* Projet 3: Green Challenger */}
                        <GreenChallengerProject />


                    </div>
                </section>

                {/* ================================================ */}
                {/* SECTION CALL-TO-ACTION FINALE */}
                {/* ================================================ */}
                <section className="relative py-24 md:py-32 overflow-hidden">
                    <div className="container mx-auto px-4 text-center relative z-10">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className="max-w-4xl mx-auto"
                        >
                            {/* Titre */}
                            <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6 md:mb-8 leading-tight tracking-tight">
                                Prêt à
                                <span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-600 bg-clip-text text-transparent px-2 sm:px-4">
                                    créer
                                </span>
                                votre projet ?
                            </h2>

                            {/* Description */}
                            <p className="text-gray-300 text-base sm:text-xl mb-10 md:mb-12 max-w-2xl mx-auto leading-relaxed px-4">
                                Transformons ensemble votre vision en une réalité digitale exceptionnelle
                            </p>

                            {/* Boutons d'action */}
                            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 px-6 sm:px-0">
                                <button
                                    onClick={() => navigate("/Contact")}
                                    className="w-[220px] sm:w-[340px] cursor-pointer px-6 py-2 sm:px-8 sm:py-5 text-center text-[12px] sm:text-lg font-medium group relative bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold rounded-full overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/30"
                                >
                                    <span className="relative z-10 flex items-center justify-center gap-3">
                                        Discutons de votre projet
                                        <ArrowRight className="w-5 h-5 md:w-7 md:h-7 group-hover:translate-x-2 transition-transform" />
                                    </span>
                                </button>

                                <button
                                    onClick={() => navigate("/Services")}
                                    className="w-[220px] sm:w-[280px] cursor-pointer px-6 py-2 sm:px-8 sm:py-5 text-center text-[12px] sm:text-lg font-medium group relative bg-transparent border-2 border-gray-600 text-white font-semibold rounded-full overflow-hidden transition-all duration-300 hover:border-blue-500/50 hover:bg-white/5"
                                >
                                    Découvrir nos services
                                </button>
                            </div>
                        </motion.div>
                    </div>
                </section>

                {/* ================================================ */}
                {/* FOOTER */}
                {/* ================================================ */}
                <div className="relative">
                    <div className="absolute inset-0 bg-linear-to-br from-gray-900 via-black to-blue-900 z-0" />
                    <div className="relative z-10">
                        <Footer />
                    </div>
                </div>
            </Wrapper>
        </div>
    );
}
